import React,{useState, useContext, useEffect} from "react";
import { useParams } from "react-router-dom";

import UserContext from "../../context/AuthContext";

// @mui
import { 
    Box,
    Stack,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox
 } from '@mui/material';

import axios from 'axios';

const ClientClubDeBeneficios = ({updateState}) => {
    
    const { jwt  } = useContext(UserContext);
    const { id } = useParams();

    const urlCliente  = 'https://api.lessin.pe/wp-json/wp/v2/clientes';

    const [beneficiosList,setBeneficiosList] = useState([
        {
            name:'Beneficios',
            value:'beneficios',
        },
        {
            name:'Descuentos',
            value:'descuentos',
        }
    ]);

    const [ beneficiosSelect, setBeneficiosSelect ] = useState([]);

    const handleChange = (e) => {
        const { value, checked } = e.target;

        if (checked) {
            setBeneficiosSelect(prev => [...prev, value]);
        } else {
            setBeneficiosSelect(prev => prev.filter(item => item !== value));
        }
    };

    const getCliente = () =>{
        updateState(true)
        axios.get(urlCliente+'/'+id).then((resp)=>{
            updateState(false);
            setBeneficiosSelect(resp.data.acf.clientes_club_beneficios || []);
        })
    }

    const actualizaBeneficios = () =>{
        updateState(true)
        axios.post(urlCliente+'/'+id,
        {
            status: "publish",
            acf:{
                clientes_club_beneficios:beneficiosSelect,
            }
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            }
        }).then((data)=>{
            updateState(false);
        }).catch((error) => {
            console.log('error',error);
        });
    }

    useEffect(()=>{
        getCliente();
    },[])

    return (
        <Box>
            <Stack spacing={2}>
                {beneficiosList &&
                    <FormGroup>
                        {beneficiosList.map((item) => (
                            <FormControlLabel
                            key={item.value+'clubEditAdmin'}
                            label={item.name}
                            control={
                                <Checkbox
                                    value={item.value}
                                    checked={beneficiosSelect.includes(item.value)}
                                    onChange={handleChange}
                                />
                            }
                            />
                        ))}
                    </FormGroup>
                }
            </Stack>
            <Button 
                variant="contained" 
                //startIcon={<AddIcon />}
                sx={{mt:2}}
                onClick={actualizaBeneficios}
            >
                Actualizar
            </Button>
        </Box>
    )
};

export default ClientClubDeBeneficios;
